export const IMAGE_FRAGMENT = `{
  accessibilityLabel
  backgroundColor
  imageSize
  name
  url
}`
